<template lang="pug">
  section.ability(id="ability")
    h1(:class="titleAnimation") 技术能力
    .content
      div(v-for="(item, index) in nowOps.abilitiesList" :class="[contentAnimation, `animateDelay-${index}`]")
        h3 {{ item.title }}
        span(v-for="ability in item.abilities")
          p {{ ability }}
</template>

<script>
  import Mixin from '../index.js'
  export default {
    name: "ability",
    mixins: [Mixin],
  };
</script>

<style scoped lang="stylus">
  @import "../index.styl"
  .ability {
    padding 100px 0
    VStack(center)
    width 100%
    background-color #f8f8f8
    h1 {
      margin-bottom 50px
    }
    .content {
      HStack(center, center)
      flex-wrap wrap
      margin -15px
      width 1220px
      > div {
        border-radius 8px
        height 245px
        width 370px
        box-sizing border-box
        padding 22px 14px
        background-position center
        background-repeat no-repeat
        background-size 100%
        transition all .3s
        margin 15px
        &:nth-child(1) {
          background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E6%95%B0%E6%8D%AE%E8%81%9A%E5%90%88%E5%A4%84%E7%90%86%E4%BA%A4%E6%8D%A2%E8%83%BD%E5%8A%9B%E5%BA%95%E6%9D%BF.png")
        }
        &:nth-child(2) {
          background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E8%B6%85%E5%A4%A7%E8%A7%84%E6%A8%A1%E6%95%B0%E6%8D%AE%E8%AE%A1%E7%AE%97%E8%83%BD%E5%8A%9B%E5%BA%95%E6%9D%BF.png")
        }
        &:nth-child(3) {
          background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E6%95%B0%E6%8D%AE%E5%B7%A5%E4%BD%9C%E6%B5%81%E5%BA%95%E6%9D%BF.png")
        }
        &:nth-child(4) {
          background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E5%BA%95%E6%9D%BF.png")
        }
        &:nth-child(5) {
          background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E5%BA%95%E6%9D%BF2.png")
        }
        &:nth-child(6) {
          background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E5%BA%95%E6%9D%BF3.png")
        }
        &:hover {
          box-shadow 0 12px 40px 0 #d6d6d6
          position relative
        }
        h3 {
          margin-top -4px
          margin-bottom 8px
          FontSetting("思源黑体")
          font-weight normal
          font-size (22 / 14)rem
        }
        > span {
          HStack()
          margin-bottom 8px
          &::before {
            content ""
            border-top 4px solid transparent
            border-bottom 4px solid transparent
            border-left 6px solid #269bff
            margin-top 7px
            margin-right 4px
          }
          p {
            padding 0
            margin 0
            FontSetting("思源黑体 CN Normal")
            color #666
            font-size (14 / 14)rem
            line-height 24px
          }
        }
      }
    }
    @media (max-width ipadProScreenWidth) {
      .content {
        width 100%
      }
    }
    @media (max-width screenWidth){
      padding 50px 0
      h1 {
        margin-bottom 0
      }
      .content {
        VStack(center)
        width 100%
        > div {
          padding 16px
          width calc(100% - 30px - 32px)
          min-height max-content
          background-size 100% 100%
          h3 {
            font-size 22px
            margin-bottom 10px
          }
          p {
            font-size 14px
          }
        }
      }
    }
  }
</style>
